export default "__VITE_ASSET__o5ryAhqy__"